export const nullcheckAllObjProperty = (obj: Record<string, unknown>) => {
  const values = Object.values(obj);
  const countNull = values.filter((x) => x).length;
  return values.length === countNull;
};
